<ui-breadcrumb [nodes]="breadcrumb()"></ui-breadcrumb>

<div class="bundle-navigation">
  @if (navigationTree(); as navigationTree) {
    <ui-upkeep-navigation
      [data]="navigationTree"
      [current]="navigationTree![0].children![0]"
      [disableRouter]="!isCepApp()"
    ></ui-upkeep-navigation>
  }
</div>

<div class="page-content-wrapper">
  <div class="page-content">
    @if (products(); as products) {
      <ui-cms-outlet class="cms-bundle-content" [config]="{ contentId: 3126 }"></ui-cms-outlet>
      <ui-product-bundles-list [products]="products.products"></ui-product-bundles-list>
    } @else {
      <ui-product-list-skeleton [count]="3" class="in-row"></ui-product-list-skeleton>
    }
  </div>
</div>
